function Screw({ className }: { className: string }) {
  return (
    <div
      className={`absolute aspect-square w-[3.2%] rounded-full ${className}`}
      style={{
        background:
          "linear-gradient(45deg, transparent 44%, #111 45%, #111 55%, transparent 56%), radial-gradient(circle, #747474 0%, #3c3c3c 58%, #171717 100%)",
        boxShadow: "0 1px 1px rgba(0,0,0,0.7)",
      }}
    />
  );
}

function Reel({ className }: { className: string }) {
  return (
    <div
      className={`media-cassette-reel absolute aspect-square w-[22%] rounded-full ${className}`}
      style={{
        background:
          "repeating-conic-gradient(from 0deg, #d9d5ca 0deg 12deg, #242526 13deg 28deg), radial-gradient(circle, #171819 0%, #2d2f30 100%)",
        boxShadow:
          "inset 0 0 0 9px #202223, inset 0 0 0 10px rgba(255,255,255,0.14), 0 0 0 2px #0d0e0f, 0 2px 4px rgba(0,0,0,0.65)",
      }}
    >
      <div className="absolute inset-[38%] rounded-full bg-[#ddd8ca] shadow-[inset_0_0_0_2px_#242526]" />
    </div>
  );
}

export function CassetteTape({ title, artistName }: { title: string; artistName: string | null }) {
  return (
    <div
      className="media-disc-cassette absolute top-[22%] z-0 flex h-[55%] w-[85%] items-center justify-center overflow-hidden rounded-[5%]"
      style={{
        background: "linear-gradient(145deg, #3a3c3d 0%, #17191a 18%, #242627 55%, #0d0e0f 100%)",
        boxShadow:
          "inset 0 2px 1px rgba(255,255,255,0.13), inset 0 -3px 5px rgba(0,0,0,0.7), 0 10px 28px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.14)",
      }}
    >
      {/* Fine molded-plastic texture. */}
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "repeating-linear-gradient(100deg, transparent 0 2px, rgba(255,255,255,0.018) 2px 3px)",
        }}
      />

      {/* Paper label modeled after classic commercial cassettes. */}
      <div className="absolute inset-x-[7%] top-[8%] h-[52%] rounded-[3%] bg-[#d9d5c9] shadow-[inset_0_0_0_1px_rgba(35,35,32,0.45),0_1px_2px_rgba(0,0,0,0.7)]">
        <div className="absolute inset-x-[5%] top-[8%] flex items-baseline gap-[4%] overflow-hidden text-[#191a1a]">
          <span className="shrink-0 text-[clamp(5px,1.15vw,8px)] font-black tracking-[0.08em]">
            A
          </span>
          <div className="min-w-0 leading-none">
            {artistName && (
              <div className="truncate text-[clamp(5px,1.05vw,7px)] font-bold uppercase tracking-[0.08em]">
                {artistName}
              </div>
            )}
            <div className="mt-[3%] truncate text-[clamp(5px,1.05vw,7px)] font-semibold">
              {title}
            </div>
          </div>
          <span className="ml-auto shrink-0 text-[clamp(4px,0.9vw,6px)] font-bold tracking-widest text-black/60">
            GARIMPA
          </span>
        </div>

        {/* Recessed tape window behind the reels. */}
        <div className="absolute inset-x-[15%] bottom-[9%] h-[36%] rounded-sm bg-[#121313] shadow-[inset_0_2px_5px_rgba(0,0,0,0.9),0_0_0_1px_rgba(0,0,0,0.55)]">
          <div className="absolute inset-x-[24%] top-[28%] h-[30%] rounded-sm bg-[#29231d] shadow-[inset_0_0_5px_#090909]" />
          <div className="absolute inset-x-[34%] bottom-[14%] h-[9%] bg-[#5b3a24]" />
        </div>
        <Reel className="bottom-[4%] left-[13%]" />
        <Reel className="bottom-[4%] right-[13%]" />
        <div className="absolute bottom-[3%] left-1/2 -translate-x-1/2 text-[clamp(4px,0.8vw,6px)] font-bold tracking-[0.18em] text-black/65">
          NORMAL BIAS 120 µs
        </div>
      </div>

      {/* Lower transport recess and guide holes. */}
      <div
        className="absolute inset-x-[20%] bottom-[6%] h-[26%] bg-[#101112] shadow-[inset_0_2px_5px_rgba(0,0,0,0.9),0_0_0_1px_rgba(255,255,255,0.09)]"
        style={{ clipPath: "polygon(8% 0, 92% 0, 100% 100%, 0 100%)" }}
      >
        <div className="absolute bottom-[20%] left-[17%] size-[13%] rounded-full bg-[#050505] shadow-[0_0_0_2px_#484a4a]" />
        <div className="absolute bottom-[20%] right-[17%] size-[13%] rounded-full bg-[#050505] shadow-[0_0_0_2px_#484a4a]" />
        <div className="absolute bottom-[17%] left-1/2 h-[20%] w-[7%] -translate-x-1/2 rounded-full bg-[#050505] shadow-[0_0_0_1px_#555]" />
      </div>

      <Screw className="left-[3.5%] top-[5%]" />
      <Screw className="right-[3.5%] top-[5%]" />
      <Screw className="bottom-[4%] left-[4%]" />
      <Screw className="bottom-[4%] right-[4%]" />
      <Screw className="bottom-[4%] left-1/2 -translate-x-1/2" />

      <div className="pointer-events-none absolute inset-[1.5%] rounded-[4%] border border-white/5" />
    </div>
  );
}
